/**
 * Кеш последних вопросов пользователя в AI Tutor (localStorage).
 * Используется для быстрого повтора или подсказки при вводе.
 */

const STORAGE_KEY = "ai-tutor-recent-questions";
const MAX_ITEMS = 10;

function normalizeForDedup(text: string): string {
  return text.trim().toLowerCase();
}

export function getRecentQuestions(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === "string" && x.trim().length > 0).slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

/**
 * Добавляет вопрос в начало списка, убирает дубликаты (по нормализованному тексту), обрезает до MAX_ITEMS.
 */
export function addRecentQuestion(question: string): void {
  const text = question.trim();
  if (!text) return;
  try {
    const prev = getRecentQuestions();
    const norm = normalizeForDedup(text);
    const filtered = prev.filter((q) => normalizeForDedup(q) !== norm);
    const next = [text, ...filtered].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (e) {
    if (typeof console !== "undefined") console.warn("[recentQuestionsStorage] save failed:", e);
  }
}
